/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// import styled from 'styled-components';
// import { BreakPoint, Color, Font, FontSize } from '../../asset/styles';

import Close from '../../component/button/Close';
import NpsRadios from './children/NpsRadios';
import Input from '../../../common/primitive';
import NpsGuide from './children/NpsGuide';
import {
  StyledBox,
  StyledClose,
  StyledGuideDiv,
  StyledMessage,
  StyledMessageBox,
  StyledRadiosBox,
} from './style';

/**
 * {@link Nps} header message component を出力します
 * @param {string} message header text
 * @param {*} [StyledComponent=StyledMessage] styled component - embedded / popup 切り替えるために props で指定できるようにします
 * @return {*} React.node 返します
 * @constructor
 * @since 20191211 - StyledComponent argument 追加します
 */
export const Message = ({ message, StyledComponent = StyledMessage }) => {
  return (
    <StyledComponent className={'Nps-StyledMessage'}>{message}</StyledComponent>
  );
};

/**
 * {@link Nps} popup type close button component を出力します
 * @param {?function} action click callback
 * @param {string} color {@link Close} props.color value へ設定します
 * @return {*} React.node
 * @constructor
 */
export const CloseButton = ({ action, color }) => {
  const onClick = useCallback(
    event => {
      event.preventDefault();
      if (typeof action === 'function') {
        action.call(this);
      }
    },
    [action]
  );

  return (
    <StyledClose>
      <Close onClick={onClick} color={color} />
    </StyledClose>
  );
};

/**
 * NPS component
 * - {@link NpsRadios} radio button
 * - {@link NpsGuide} min / max 文字列
 * @param {string} name radioo button name
 * @param {Array<{value: string, name: string}>} optionValues radio value 属性値
 * @param {number|string} [alreadyChecked=-1] - checked radio button data-index number, popup / embedded 切替時に checked 状態を維持するために使用します
 * @param {boolean} [generator=false] generator flag
 * @param {*} props React.props
 * @return {*} React.node - NPS component
 * @constructor
 */
const Nps = ({
  name,
  optionValues,
  alreadyChecked = -1,
  generator = false,
  ...props
}) => {
  // const onChange = useCallback(() => {}, []);
  // console.log('Nps - alreadyChecked', alreadyChecked)
  // embedded + after checked の時は rendering しない(null)
  if (props.embedded && props.className) {
    return null;
  }
  return (
    <StyledBox className={`Nps ${props.className}`}>
      <StyledMessageBox>
        <Message {...props} />
        <Input
          type={'hidden'}
          name={props.config.nps.question.name}
          value={props.config.nps.question.value}
        />
        <CloseButton action={props.onCloseClick} color="red" />
      </StyledMessageBox>
      <StyledRadiosBox>
        <NpsRadios
          name={name}
          optionValues={optionValues}
          // onChange={props.onChange ? props.onChange : onChange}
          onChange={props.onChange ? props.onChange : null}
          alreadyChecked={alreadyChecked}
          generator={generator}
        />
      </StyledRadiosBox>
      <StyledGuideDiv>
        <NpsGuide txt0={props.config.nps.txt0} txt1={props.config.nps.txt1} />
      </StyledGuideDiv>
    </StyledBox>
  );
};

// Nps.propTypes = {
//   message: PropTypes.string.isRequired,
//   className: PropTypes.string,
//   name: PropTypes.string,
//   optionValues: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string,
//       value: PropTypes.string,
//     })
//   ).isRequired,
//   onCloseClick: PropTypes.func,
// };

export default Nps;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/nps/Nps.js